import { createApiActionType, createActionType } from 'app/store/utils';

const apiType = createApiActionType('websocket');
const type = createActionType('websocket');

export const WEBSOCKET_AUTH = apiType('Auth');
export const WEBSOCKET_ERROR = type('Error');
export const WEBSOCKET_STATUS = type('Status');
export const WEBSOCKET_CONNECT = type('Connect');
